import { ChangeEvent, KeyboardEvent, useRef, useState } from "react";
import { actionBarMinWidthWrapper, SearchSpacer } from "src/components/common/common";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { XButtonForm } from "src/components/common/form/XButtonForm";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { useSYS3010_R01Store } from "src/containers/mes/SYS/SYS3010_R01/Store_SYS3010_R01";
import { usePRD2010_R01Store } from "./Store_PRD2010_R01";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchSection_PRD2010_R01 = (props: Props) => {

	const { onEnterKeyDown } = props;

	const { PRD2010_R01Filter, setPRD2010_R01Filter } = usePRD2010_R01Store();
	const { compCdList, workPlaceList, jobTeamList, yesNoList } = useCommonCodeStore();

	
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

  return (
	<SearchSectionDoubleForm >
		<SearchDropDownForm
			label="사업장"
			value={PRD2010_R01Filter.compCd}
			onChangeItem={(item) => setPRD2010_R01Filter({ compCd: item?.compCd || ''})}
			optionList={compCdList}
		/>
		<SearchDateRangeForm
                label="생산일자"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                dateRange={PRD2010_R01Filter.dateRange}
                setDateRange={v => setPRD2010_R01Filter({  dateRange: v})}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
		<SearchDropDownForm
			label="작업공정"
			value={PRD2010_R01Filter.workplaceCd}
			onChangeItem={(item) => setPRD2010_R01Filter({ workplaceCd: item?.workplaceCd || ''})}
			optionList={workPlaceList.filter(opt => opt.compCd === PRD2010_R01Filter.compCd)}
			editable={PRD2010_R01Filter.compCd !== ''}
		/>
        <SearchSpacer/>
		<SearchDropDownForm
			label="작업팀"
			value={PRD2010_R01Filter.jobTeam}
			onChangeItem={(item) => setPRD2010_R01Filter({ jobTeam: item?.minorCd || ''})}
			optionList={jobTeamList}
		/>
		<SearchDropDownForm
			label="마감여부"
			value={PRD2010_R01Filter.closeTag}
			onChangeItem={(item) => setPRD2010_R01Filter({ closeTag: item?.minorCd || ''})}
			optionList={yesNoList}
		/>
	</SearchSectionDoubleForm>
  );
};